import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SessionGridComponent } from '@go-modules/components/activity-view/session-grid/session-grid.component';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { SessionCardModule } from '@go-modules/components/activity-view/session-card/session-card.module';
import { GridVirtualScrollViewportModule } from '@go-modules/components/grid-virtual-scroll-viewport/grid-virtual-scroll-viewport.module';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		SessionCardModule,
		GridVirtualScrollViewportModule
	],
	declarations: [
		SessionGridComponent
	],
	exports: [
		SessionGridComponent
	]
})
export class SessionGridModule {}
